<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <section class="comp-doc-section ql-editor" :style="styles" v-html="compProps.content"></section>
</template>
<script>
export default {
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  computed: {
    styles() {
      return {
        'background-color': this.compProps.backgroundColor,
        margin: this.compProps.margin,
        padding: this.compProps.padding,
        border: this.compProps.border,
        'border-radius': this.compProps.borderRadius,
        'box-shadow': this.compProps.boxShadow
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.comp-doc-section {
  position: relative;
}
</style>
